import {useSearchBox} from "react-instantsearch";
import {Input} from "antd";

export const CustomSearchBox = ({ onChange }: { onChange?: (query: string) => void }) => {
    const { refine } = useSearchBox();

    return (
        <Input.Search
            placeholder='Search for a vod asset to prefill from or enter the details below..'
            allowClear
            onSearch={onChange}
            onChange={(e) => {
                refine(e.target.value)

                if (typeof onChange === 'function') {
                    onChange(e.target.value)
                }
            }}
        />
    );
};